import React, { Component } from "react";
import Icons from '../../../icon';
class CustomDragDrop extends Component {
    render() {
        return(
            <div className="custom-disabled">
                <div className="filepicker dropzone dz-disabled dz-clickable">  
                <div>
                    <Icons name="cloud-upload" customClassName="cloud-upload" />
                    <span></span>
                </div> 
                    <div className="dz-default dz-message">
                        <span>Drag and drop or <b className="purple">browse</b> your files</span>
                </div></div>
            </div>
        )
    }
}

export default CustomDragDrop